export const HEADER_IMAGES_FIELDS = ['headerImage1', 'headerImage2', 'headerImage3'];
export const IMAGE_ACTIONS = {
  DELETE_IMAGE: 'delete',
  DONT_UPDATE_IMAGE: 'no-update'
};